export function map() {
  if ($('#map').length) {
    var searchMap = function () {
      var map = $('#map');
      var infowindow = new google.maps.InfoWindow({
        content: locationsAsset[0][0],
        position: {
          lat: 50.0290229,
          lng: 30.3400199
        }
      });
      var markerPosition = new google.maps.LatLng(locationsAsset[0][1], locationsAsset[0][2]);
      var centerPosition = new google.maps.LatLng(locationsAsset[0][1], locationsAsset[0][2]);

      var mapOptions = {
        zoom: 17,
        center: centerPosition,
        scrollwheel: false,
        mapTypeControl: false,
        draggable: true,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        },
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [
          {
            featureType: "all",
            elementType: "all",
            stylers: [
              { saturation: -50 }
            ]
          }
        ]
      };
      var map = new google.maps.Map(document.getElementById("map"), mapOptions);
      const marker = new google.maps.Marker({
        map: map,
        // draggable: true,
        animation: google.maps.Animation.DROP,
        position: {
          lat: locationsAsset[0][1],
          lng: locationsAsset[0][2]
        },
        icon: {
          url: '/wp-content/themes/aspira_custom/assets/images/marker.png',
          scaledSize: new google.maps.Size(48, 48)
        }
      });
      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker);
      });
      if ($(this).width() > 1025) {
        infowindow.open(map, marker);
      }
      // markers.push(marker);

      // marker.addListener('mouseover', toggleBounce);


      // function toggleBounce() {
      // marker.setAnimation(google.maps.Animation.BOUNCE);
      // setTimeout(function() {
      // marker.setAnimation(null);
      // }, 4000)
      // }
      var data = '';
      marker.setMap(map);
    }
    searchMap();
  }
};



// WEBPACK FOOTER //
// app/scripts/components/map.js